exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chat-textbox{margin-bottom:10px;position:relative}.editable-div{width:300px;height:50px;border:1px solid #ccc;padding:10px;overflow-y:auto;white-space:pre-wrap;outline:none;cursor:text;font-family:Arial,sans-serif;font-size:14px;line-height:1.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-84793fea","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/discuss/prac/ChatComponent.vue
// module id = 1007
// module chunks = 0